import {
  APPLIANCE_PAGINATED_FETCH_STARTED,
  APPLIANCE_PAGINATED_FETCH_SUCCEEDED,
  APPLIANCE_PAGINATED_FETCH_FAILED,
  APPLIANCE_PAGINATED_CHANGE_PAGE,
  APPLIANCE_PAGINATED_CLEAR
} from '#action/types';
import { webPortalApi } from '#config/web-portal-api';
import { snackBarError } from '#action/fetch';
import { fetchApplianceDevicesDetailed, applianceDevicesClear } from './appliance-devices';
import { getRequestOptions, getURLParameter } from '#helper';

let abortController = new AbortController();

export const fetchAppliances = () => async (dispatch, getState) => {
  try {
    const {
      page,
      order,
      itemsPerPage,
      orderBy,
      filterBy
    } = getState().appliancesPaginated;
    abortController.abort();

    dispatch({
      type: APPLIANCE_PAGINATED_FETCH_STARTED
    });

    const limit = itemsPerPage;
    const p = getURLParameter('page') || page;
    const offset = (p - 1) * itemsPerPage;
    const { warehouse } = getState().listFilter;
    const searchValue = warehouse?.search?.value;
    const projectValue = warehouse?.project?.value;
    const warehouseValue = warehouse?.warehouse?.value;
    const applianceStatus = warehouse?.applianceStatus?.value;
    const searchParams = new URLSearchParams({ limit, offset, order, orderBy, pagination: true });

    if (searchValue) {
      searchParams.set('filter', searchValue);
      searchParams.set('filterBy', filterBy);
    }

    if (projectValue) {
      const ids = projectValue.map(v => v.data.id).join(',');

      if (ids) {
        searchParams.set('project', ids);
      }
    }

    if (warehouseValue) {
      const ids = warehouseValue.map(v => v.data.id).join(',');

      if (ids) {
        searchParams.set('warehouse', ids);
      }
    }

    if (applianceStatus?.length) {
      const appStatus = applianceStatus[0].data.value;

      if (appStatus === 'all') {
        searchParams.delete('status');
      } else {
        searchParams.set('status', appStatus);
      }
    }

    const url = webPortalApi.buildApiUrl(`warehouse/appliance?${searchParams.toString()}`);

    abortController = new AbortController();
    const { signal } = abortController;
    // Debounce to do not send multiple requests in short time
    await new Promise(res => {
      setTimeout(() => {
        res();
      }, 200);
    });
    const res = await fetch(url, { ...getRequestOptions(), signal });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }
    if (!res.ok) {
      throw await res.json();
    }

    const { appliances = [], last } = await res.json();

    if (appliances.length) {
      await dispatch(fetchApplianceDevicesDetailed(appliances.map(el => el.id).join(',')));
    }

    return dispatch({
      type: APPLIANCE_PAGINATED_FETCH_SUCCEEDED,
      payload: appliances,
      totalCount: last
    });
  } catch (e) {
    if (e.name === 'AbortError') {
      return false;
    }

    dispatch(snackBarError({ message: 'Error in request' }));

    return dispatch({
      type: APPLIANCE_PAGINATED_FETCH_FAILED,
      error: e
    });
  }
};

export const changePage = (newPage, { refetch = true } = {}) => dispatch => {
  dispatch({
    type: APPLIANCE_PAGINATED_CHANGE_PAGE,
    payload: newPage
  });

  if (refetch) {
    dispatch(fetchAppliances());
  }
};

export const clear = () => dispatch => {
  abortController.abort();
  dispatch(applianceDevicesClear());
  dispatch({
    type: APPLIANCE_PAGINATED_CLEAR
  });
};
